import styled from 'styled-components';
import Button from '../../../_shared/components/Button';
import Label from '../../../_shared/components/Label';

export const Container = styled.div`
  border-radius: 3px;
  text-align: center;
`;

export const StyledHeading = styled(Label)`
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  line-height: ${({ theme }) => theme.FONT_SIZES.LARGE};
  margin-bottom: 24px;
`;

export const StyledSubHeading = styled(Label)`
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  line-height: 20px;
  margin-bottom: 24px;
`;

export const StyledCancel = styled(Button.Transparent)`
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  line-height: ${({ theme }) => theme.FONT_SIZES.SMALL};
  text-align: center;
  letter-spacing: 1.37143px;
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  background-color: ${({ theme }) => theme.COLORS.BASE};
  float: right;
`;
